import { Box, Slider, Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { AdditionalOptimizationDetails } from './useCreateTourState';

type TimeOptimizationAdditionalOptionsProps = {
  onChange: (value: AdditionalOptimizationDetails) => void;
  value: AdditionalOptimizationDetails;
};

export const TimeOptimizationAdditionalOptions: React.FC<
  TimeOptimizationAdditionalOptionsProps
> = ({ value, onChange }) => {
  const [t] = useTranslation('tours');
  return (
    <Stack alignItems="center" justifyContent="center">
      <Typography
        fontWeight={700}
        my={6}
        fontSize={16}
        sx={{ color: 'grey.900' }}
      >
        {t('optimizeOptionDetails.titles.additionalDetails')}
      </Typography>
      <Stack gap={6} width="100%">
        <TimeOptimizationAdditionalOptionsSlider
          title={t('optimizeOptionDetails.titles.matchingRadius')}
          subtitle={t('optimizeOptionDetails.descriptions.matchingRadius')}
          value={value.radius}
          handleChange={(val) => onChange({ ...value, radius: val })}
          unit="km"
          min={1}
          max={20}
          stepSize={1}
        />
        <TimeOptimizationAdditionalOptionsSlider
          title={t('optimizeOptionDetails.titles.additionalDegassedJobs')}
          subtitle={t(
            'optimizeOptionDetails.descriptions.additionalDegassedJobs'
          )}
          value={value.additionalDegassedJobs}
          handleChange={(val) =>
            onChange({ ...value, additionalDegassedJobs: val })
          }
          unit="%"
          min={0}
          max={50}
          stepSize={5}
        />
      </Stack>
    </Stack>
  );
};

const TimeOptimizationAdditionalOptionsSlider: React.FC<{
  value: number;
  handleChange: (newValue: number) => void;
  unit: string;
  title: string;
  subtitle: string;
  min: number;
  max: number;
  stepSize: number;
}> = ({ value, handleChange, unit, title, subtitle, min, max, stepSize }) => {
  return (
    <Stack
      sx={(theme) => ({
        p: 4,
        backgroundColor: theme.palette.background.paper,
        gap: 2,
        borderRadius: 2,
      })}
    >
      <Typography fontWeight={700} fontSize={16} color="grey.900">
        {title}
      </Typography>
      <Typography>{subtitle}</Typography>
      <Stack direction="row" alignItems="center" gap={3}>
        <Slider
          value={value}
          onChange={(_, val) => {
            handleChange(Array.isArray(val) ? val[0] : val);
          }}
          min={min}
          max={max}
          step={stepSize}
        />
        <Box
          sx={(theme) => ({
            border: `1px solid ${theme.palette.primary.main}`,
            paddingY: 2,
            paddingX: 3,
            borderRadius: 2,
            minWidth: 80,
            textAlign: 'center',
          })}
        >
          <Typography
            noWrap
            color="grey.900"
            fontWeight={700}
          >{`${value} ${unit}`}</Typography>
        </Box>
      </Stack>
    </Stack>
  );
};
